import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { clearSelectServerEpic } from './_epics/clearSelectServer.epic';
import { toggleSelectServerEpic } from './_epics/toggleSelectServer.epic';
import { initServersFilterEpic } from './_epics/initServersFilter.epic';

export const serversFilterEpic = safeCombineEpics(
  clearSelectServerEpic,
  toggleSelectServerEpic,
  initServersFilterEpic,
);
